import {
  OpcionPreguntaCuestionarioSnp,
  PreguntaCuestionarioSnp,
  RespuestaComparacion,
  RespuestaCuestionarioSnp,
} from '@/shared/model/snp/cuestionario.model';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class PreguntaSnpComponent extends Vue {
  @Prop({ required: true })
  public pregunta: PreguntaCuestionarioSnp;

  @Prop({ required: true })
  public index: number;

  @Prop({ required: false, default: false })
  public esMoloLectura: boolean;

  @Prop({
    required: false,
    default: function () {
      return new RespuestaCuestionarioSnp();
    },
  })
  public contestacionInicial: RespuestaCuestionarioSnp;

  @Prop({ required: true, default: [] })
  public comparaciones: Array<RespuestaComparacion>;

  public opcionRespuesta: OpcionPreguntaCuestionarioSnp = {};
  public respuestaCampoTexto = '';

  public contestacion: RespuestaCuestionarioSnp = {};

  public mostrarIndividualesVista = true;

  @Watch('contestacionInicial')
  public watchContestacionInicial(): void {
    this.contestacion = RespuestaCuestionarioSnp.fromObject(this.contestacionInicial);
    this.opcionRespuesta = this.pregunta.opciones.find(opcion => opcion.id == this.contestacion.respuestaId) ?? {};
    this.respuestaCampoTexto = this.contestacion.respuestaCampoTexto ?? '';
  }

  @Emit('contestar')
  public emitirContestacion(): RespuestaCuestionarioSnp {
    return new RespuestaCuestionarioSnp(
      this.pregunta.dimension,
      this.pregunta.criterio,
      this.pregunta.id,
      this.pregunta.pregunta,
      this.pregunta.ponderacion,
      this.opcionRespuesta?.id,
      this.opcionRespuesta?.texto,
      this.opcionRespuesta?.valor,
      this.opcionRespuesta?.descripcion,
      this.pregunta.campoTexto,
      this.respuestaCampoTexto
    );
  }
}
